const MuiAutocomplete = {
  styleOverrides: {
    root: {
      '& .MuiAutocomplete-inputRoot, & .MuiOutlinedInput-root': {
        padding: '7px',
        paddingLeft: '9px',
      },
    },
  },
};

export default MuiAutocomplete;
